import uk from "vuetify/lib/locale/uk";

export default {
  ...uk,
  locale: {
    switcherLabel: "Оберіть мову",
  },
  main: {
    paymentAlert: `Ви маєте заплановану сесію на {0}. Для проведення планового платежу за 12 годин до початку сенасу прив'яжіть, будь ласка, картку.`,
    route: {
      enter: "Вхід",
      registration: "РЕЄСТРАЦІЯ",
    },
    header: {
      menu: {
        consultation: "Консультація",
        cabinet: "Кабінет",
        main: "Головна",
        settings: "Налаштування",
        specialization: "Спеціалізація",
        schedule: "Розклад",
        blog: "Блог",
        psychologists: "Психологи",
        categories: "Категорії",
        help: "Допомога",
        exit: "Вихід",
        payment: "Оплата",
        ourPsychologists: "Наші терапевти",
        favorites: "Обрані",
        myQuestions: "Мої запитання",
        guide: "Інструкція та налаштування",
        guideShort: "Інструкція",
      },
      menuItem1: 'Про проєкт',
      menuItem3: 'Для психологів',
      menuItem4: 'Блог',
      menuItem5: 'Для бізнесу',
      // menuItem5: 'Про нас',
      EnterButton: 'Вхід'
    },
    redactorDashboard: {
      author: "Автор статті (психолог)",
      authorUrl: "Або посилання для кнопки «Про автора»",
      authorHint: "Кнопка «Про автора» у статті веде на сторінку психолога, у «Команди Платформи» — на каталог психологів",
      authorTeam: "Команда Платформи",
      likes: "Лайки (кількість на сайті)",
      redactors: {
        title:
          "У цьому розділі ви можете створити/видалити профіль редактора для блогу",
        createRedactor: "Створити профіль редактора",
        delete: "Видалити",
        cancel: "Скасувати",
        accept: "Застосувати",
        name: "Ім'я*",
      },
      blog: {
        title:
          "У цьому розділі ви можете створити нову статтю або редагувати раніше створену",
        allBlogs: "Усі раніше створені статті:",
        create: "Створити",
        all: "Усі",
        published: "Опубліковані",
        waiting: "Заплановані",
        draft: "Чернетки",
        langDesk: "Кожну статтю можна створити 2 мовами",
        cancel: "Скасувати",
        accept: "Застосувати",
        createBlog: "Створити статтю",
        editBlog: "Редагувати статтю",
        publishTime: "Час публікації",
        publishDate: "Дата публікації",
        publishNow: "Опублікувати зараз",
        previewPhoto: "Фото для заголовка",
        imageSize: "Розмір картинки",
        deleteBlog: "Видалити статтю",
        deleteConfirm: "Видалити статтю назавжди? Відновити її буде неможливо.",
        deleteYes: "Так, видалити",
        viewOnSite: "Переглянути на сайті",
        saveAsDraft: "Зберегти як чернетку",
        editorHint: "Список «Текст» над полем: Заголовок і Підзаголовок розділів. Кнопка з лапками робить виділений кольоровий блок. Колір тексту і фону поруч із кнопками B, I, U, перший ряд палітри це фірмові кольори Платформи. Натисніть на картинку в тексті, щоб змінити її розмір. Порожній рядок між абзацами не потрібен.",
      },
      categories: {
        title:
          "У цьому розділі ви можете створити/видалити категорію для блогу",
        delete: "Видалити",
        create: "Створити",
        createCategory: "Створити нову категорію",
        createdCategories: "Створені категорії:",
      },
    },
    adminDashboard: {
      psychologists: {
        placement: {
          title: "Показ у каталозі",
          shownUntil: "Показується до",
          shownFree: "Показується (оплата ще не обов'язкова)",
          hidden: "Не показується",
          days: "днів",
          show: "Показувати анкету",
          hide: "Приховати анкету",
          confirmHide: "Приховати з каталогу анкету",
        },
        unmatchedPayments: {
          title: "Оплати без анкети",
          hint: "Оплата розміщення надійшла, але пошта й телефон з неї не збігаються з жодною анкетою. Оберіть психолога й натисніть «Зарахувати»: анкета покажеться в каталозі, психолог отримає лист про оплату, а наступні щомісячні оплати з цією поштою чи телефоном зарахуються йому автоматично.",
          psychologist: "Психолог",
          assign: "Зарахувати",
        },
        unpaidPlacement: {
          title: "Психологам без оплати: показ у каталозі",
          apply: "Застосувати",
          confirmTitle: "Показ без оплати",
          confirmText: "Психологів без оплати: {count}. Їхні анкети показуватимуться в каталозі {days} днів, у кабінеті буде видно, скільки днів залишилось. Після цього знадобиться оплата, як у всіх.",
          nobody: "Зараз немає активних психологів без оплати.",
          confirm: "Застосувати",
          cancel: "Скасувати",
        },
        admin_status: {
          0: "Всі",
          1: "Без статусу",
          2: "Не відповідає критеріям",
          3: "Співбесіда",
          4: "На доопрацювання",
          5: "На активацію",
          6: "В чергу",
          7: "Резерв",
          8: "Чорний список",
        },
        profile_tag: {
          0: "Всі",
          1: "Оновлено посилання на відеовізитівку",
          2: "Оброблено посилання на відеовізитівку",
        },
        month: "Місяць",
        mainTitle:
          "В даному розділі ви можете активувати/деактивувати психологів на платформі",
        changePhotoRequire: "Фото профілю вимагає підтвердження",
        changePhotoWarning: "Необхідно завантажити фото",
        changePhotoDone: "Фото профілю підтверджено",
        rating: "Рейтинг",
        current: "Поточний",
        last: "Минулий",
        swalText: {
          deleted: "Користувача успішно видалено",
          activated: "Анкета активована. Виконується оновлення списків...",
          deactivated: "Анкета деактивована. Виконується оновлення списків...",
          archived: "Анкету перенесено в архів",
          unarchived: "Анкету повернуто з архіву",
          updated: "Дані оновлено",
          invalidPhone: "Введено не вірний номер телефону",
        },
        tabs: {
          inactivePsychologists: "Нові анкети",
          activePsychologists: "Активні психологи",
          deactivatedPsychologists: "Деактивовані",
          archivedPsychologists: "Архів",
        },
        buttons: {
          confirmUpdates: "Підтвердіть зміни",
          downloadPhoto: "Завантажити фото",
          uploadPhoto: "Завантажити фото",
          downloadAll: "Завантажити все",
          download: "Завантажити",
          activate: "Активувати",
          deactivate: "Деактивувати",
          apply: "Застосувати",
          viewProfile: "Переглянути анкету",
          back: "Назад",
          forward: "Далі",
          closeForm: "Закрити анкету",
          btnEdit: "Редагувати",
          btnCancel: "Скасувати",
          btnSave: "Зберегти",
          confirmDelete: "Ви дійсно хочете видалити",
          confirmActivate: "Активувати анкету",
          confirmDeactivate: "Деактивувати анкету",
          archive: "В архів",
          unarchive: "Повернути з архіву",
          confirmArchive: "Перенести в архів анкету",
          confirmUnarchive: "Повернути з архіву анкету",
          confirmY: "Підтвердити",
          confirmN: "Відмінити",
        },
        switcherLabel: {
          yes: "Так",
          no: "Ні",
        },
        stepsTitle: {
          generalInformation: "Загальна інформація",
          mainTreatmentMethod: "Загальний метод",
          workExperience: "Досвід роботи",
          aboutInfo: "Про себе",
        },
        inputLabel: {
          main: {
            uploadPhoto: "Завантажити фото",
            stepOne: {
              firstName: "Ім'я",
              secondName: "Прізвище",
              patronymic: "По батькові",
              dateOfBirth: "Дата народження",
              citizenship: "Громадянство",
              phone: "Телефон",
              university: "Назва ВНЗ",
              faculty: "Назва факультету",
              speciality: "Спеціальність",
              scienseDegree: "Академічний або науковий ступінь",
              yearOfEnding: "Рік випуску",
            },
            stepThree: {
              workExperience: "Досвід роботи",
              additionalProgram: "Повна назва і кількість відпрацьованих годин",
            },
            stepFour: {
              from: "Від",
              to: "До",
            },
          },
          questionnaire: {
            answer: "Відповідь...",
            title: "Анкета",
            stepOne: {
              education: "Освіта",
              certificatesTitle:
                "Фото розгорнутих дипломів і сертифікатів, підтверджуючих навчання:",
            },
            stepTwo: {
              mainTreatmentMethod: "Основний метод",
              additionalEducation: "Додаткова освіта",
              problems: "Проблеми з якими працює",
            },
            stepThree: {
              workExperience:
                "Скільки років ви консультуєте? За кошти, не в рамках навчальної програми.",
              additionalProgram:
                "Які додаткові програми пройшли чи проходите на цей момент?",
              selfTherapy: "Чи проходите ви персональну психотерапію?",
              regularSupervision: "Чи проходите ви регулярно супервізії?",
            },
            stepFour: {
              aboutInfo:
                "Розкажіть про себе у вільній формі. Що вважаєте нам потрібно дізнатися про вас, щоб зрозуміти, який ви спеціаліст?",
              warning: "Ця інформація буде відображатися на сайті",
              shortDescription: "Коротко про мене (показується в картці каталогу)",
              notWorkingWith: "З чим ви не працюєте?",
              infoChannel:
                'Як ви дізналися про набір терапевтів в "Платформа"?',
              clientsQuantity:
                'Яку кількість клієнтів ви готові взяти в "Платформа"?',
              profileLinks:
                "Вкажіть посилання на профілі в соціальних мережах ",
            },
          },
        },
      },
    },
    psychologistDashboard: {
      guide: {
        title: "Інструкція та налаштування",
        instruction: "Інструкція для психологів",
        instructionText: "Як заповнити анкету, налаштувати розклад, відеозв'язок та інші можливості кабінету.",
        instructionSoon: "Інструкція з'явиться тут найближчим часом.",
        open: "Відкрити інструкцію",
        updates: "Оновлення платформи",
        noUpdates: "Оновлень поки немає.",
        new: "Нове",
        more: "Детальніше",
      },
      googleCalendar: {
        howTitle: "Як підключити Google Календар",
        title: "Розклад з Google Календаря",
        statusOn: "Підключено",
        statusError: "Помилка оновлення",
        intro: "Відмічайте час для запису клієнтів у додатку на телефоні - слоти на сайті з’являться автоматично.",
        step1: "<b>Створіть календар:</b> відкрийте <a href=\"https://calendar.google.com\" target=\"_blank\" rel=\"noopener\">calendar.google.com</a> ➔ ліворуч біля <em>«Інші календарі»</em> натисніть <code>+</code> ➔ <em>«Створити календар»</em> ➔ назвіть його, наприклад, <b>«Платформа»</b>.",
        step2: "<b>Скопіюйте посилання:</b> у налаштуваннях нового календаря знайдіть розділ <em>«Інтеграція календаря»</em> та скопіюйте <b>«Секретну адресу у форматі iCal»</b>.",
        step3: "<b>Підключіть:</b> вставте посилання у поле нижче та натисніть <b>«Підключити»</b>.",
        step4: "<b>Як це працює:</b> Створюйте події в цьому календарі через телефон (наприклад, 10:00–13:00 відкриє слоти на 10, 11 та 12 години). Розклад на сайті (з урахуванням часових поясів) оновлюється кожні 15 хвилин.",
        urlLabel: "Секретна адреса у форматі iCal",
        connect: "Підключити",
        note: "Адресу бачить лише сервер Платформи. Ми лише читаємо календар і нічого в ньому не змінюємо; заброньовані клієнтами години не змінюються. Події на весь день не враховуються.",
        connectedText: "Вільні години беруться з вашого Google Календаря. Щоб змінити розклад, змініть події в календарі.",
        syncedAt: "Оновлено",
        freeHours: "Вільних годин на місяць",
        syncNow: "Оновити зараз",
        disconnect: "Відключити календар",
        failed: "Не вдалося підключити календар",
      },
      publicPage: {
        offline: "Офлайн-консультації",
        offlineHint: "Якщо приймаєте клієнтів особисто — додайте місто (до 5). Воно з'явиться в анкеті, а клієнти знайдуть вас у фільтрі «Офлайн» каталогу. Адреса — за бажанням.",
        country: "Країна",
        city: "Місто",
        cityNotOnline: "Тут вказуйте місто, де приймаєте особисто. Онлайн-консультації вже показуються в анкеті, слово «Онлайн» писати не треба.",
        address: "Адреса або район (необов'язково)",
        addOffline: "Додати місто",
        tab: "Публічна сторінка",
        title: "Ваша іменна сторінка на Платформі",
        hint: "Персональний профіль із вашим ім'ям в URL-адресі. Додайте це посилання в Instagram, Telegram чи діліться ним у месенджерах, щоб клієнти могли легко знайти вас та записатися.",
        copy: "Копіювати",
        copied: "Посилання скопійовано",
        specialty: "Хто ви (буде в посиланні та на сторінці)",
        specialtyHint: "Наприклад: психолог, психотерапевт. Обирайте 1-2 спеціалізації, щоб посилання залишалося коротким і зручним.",
        specialtyOptions: "Психолог|Психотерапевт|Супервізор|Клінічний психолог|Сексолог|Дитячий психолог|Сімейний психолог|Консультант|Коуч",
        tooLong: "Не більше 100 символів",
        languages: "Мови консультацій",
        languagesHint: "Через кому, наприклад: українська, англійська. Показується в анкеті.",
        workCountry: "Країна, де ви працюєте",
        workCountryHint: "Ваша анкета показується в каталозі цієї країни. Якщо живете і працюєте не в Україні — оберіть свою країну.",
        introSession: "Проводжу сесію-знайомство",
        introSessionHint: "Клієнти знайдуть вас у фільтрі каталогу «Сесія-знайомство».",
        languagesTooLong: "Не більше 255 символів",
        shortDescription: "Коротко про мене",
        shortDescriptionHint: "Одне-два речення, що ви за спеціаліст. Показується в картці психолога в каталозі під методом роботи.",
        shortDescriptionTooLong: "Не більше 160 символів",
        contacts: "Контакти",
        contactsHint: "Відвідувачі побачать їх після натискання кнопки «Контакти». Кожне натискання рахується в статистиці.",
        prices: "Вартість консультацій",
        pricesHint: "Додайте всі види консультацій, які ви проводите.",
        pricesUahOnly: "Ціни консультацій тепер лише в гривнях. Вкажіть, будь ласка, у гривнях ціни, що були в доларах чи євро (виділені червоним), і збережіть.",
        priceWasInCurrency: "Раніше ціна була {price} — вкажіть, будь ласка, суму в гривнях",
        priceTitle: "Вид консультації",
        priceDuration: "Хвилин",
        priceAmount: "Ціна",
        addPrice: "Додати вид консультації",
        contact: {
          phone: "Телефон",
          email: "Email",
          telegram: "Telegram",
          viber: "Viber",
          whatsapp: "WhatsApp",
          instagram: "Instagram",
          facebook: "Facebook",
          tiktok: "TikTok",
          youtube: "YouTube",
          linkedin: "LinkedIn",
          website: "Сайт",
        },
      },
      stats: {
        title: "Статистика анкети",
        views: "Перегляди анкети",
        contactsClicks: "Натискання «Контакти»",
        contactsViews: "Перегляди контактів",
        favorites: "Додали в обране",
        favoritesSub: "за весь час",
        statusTitle: "Статус анкети",
        statusActive: "Активна",
        statusInactive: "Не активна",
        lockMessage: "Ваша анкета не активна! Щоб почати отримувати запити від клієнтів та користуватися інструментами платформи, будь ласка, активуйте підписку.",
        activateSubscription: "Активувати підписку",
        lockClose: "Закрити",
        hiddenFromCatalog: "Анкета не показується в каталозі",
        nextPayment: "Наступна оплата",
        manageSubscription: "Керувати підпискою",
        deactivated: "Ваша анкета зараз не показується на Платформі. Якщо Ви хочете відновити показ, напишіть, будь ласка, нашій службі підтримки.",
        archivedPay: "Ваша анкета зараз не показується в каталозі. Оплатіть розміщення, і вона знову з'явиться на Платформі автоматично.",
        paySubscription: "оплатити підписку",
        total: "За весь час",
        thisMonth: "Цього місяця",
        lastDays: "За 30 днів",
        placement: "Розміщення анкети",
        paidUntil: "Оплачено до",
        notPaid: "Не оплачено",
        notEnforced: "Анкета показується в каталозі",
        expired: "Термін оплати минув, анкета не показується в каталозі",
        daysLeft: "Залишилось днів",
      },
      videoRoom: {
        title: "Ваша відеокімната",
        hint: "Постійне посилання для клієнта. Кімната без обмеження часу: ви відкриваєте її, коли готові, клієнт заходить за посиланням.",
        link: "Посилання для клієнта",
        copy: "Копіювати",
        copied: "Посилання скопійовано",
        open: "Відкрити кімнату",
        close: "Закрити кімнату",
        regenerate: "Нове посилання",
        generateNew: "Генерувати нове посилання",
        regenerateConfirm: "Старе посилання перестане працювати. Продовжити?",
        opened: "Кімната відкрита",
        closed: "Кімната закрита",
        waiting: "Очікуємо клієнта…",
        guestJoined: "Клієнт у кімнаті",
        connecting: "З'єднання…",
        kick: "Завершити з клієнтом",
        cameraError: "Немає доступу до камери або мікрофона. Дозвольте доступ у браузері.",
        connectionLost: "З'єднання втрачено, пробуємо відновити…",
      },
      settings: {
        sex: "Ваша стать",
        imageInput: "Завантажити фото",
        notificationLabel: {
          1: "За 1 годину",
          2: "За 2 години",
          5: "За 5 годин",
          12: "За 12 годин",
          24: "За 24 години",
        },
        mainSettings: "Головні налаштування",
        aboutInfo: "Про себе",
        education: "Освіта",
        workExperience: "Досвід роботи",
        certificates: "Сертифікати",

        aboutYou: "Про вас",
        yourAvatar: "Ваш аватар:",
        avatarDesc:
          "Ваш аватар знаходиться на розгляді Адміністрації, це не займе багато часу.",
        avatarAlt: "Аватар психолога",
        name: "Ваше ім'я:",
        nameLabel: "Ім'я",
        lastName: "Ваше прізвище:",
        lastNameLabel: "Прізвище",
        patronymic: "Ваше по батькові:",
        patronymicLabel: "По батькові",

        timezone: "Ваш часовий пояс:",
        howOld: "Скільки вам років ?",
        birthday: "Дата народження",

        contacts: "Контакти та налаштування сповіщень",
        phone: "Телефон",
        email: "Эл. пошта",
        emailLabel: "Пошта",

        pricingTitle: "Вартість консультацій",
        pricingHint: "Вкажіть вартість у гривнях. Якщо лишити порожнім, буде застосована стандартна ціна платформи.",
        priceSinglesLabel: "Індивідуальна сесія, грн",
        priceCouplesLabel: "Парна сесія, грн",

        about_info:
          "Розкажіть про себе у вільній формі. Що вважаєте нам потрібно дізнатися про вас, щоб зрозуміти, який ви спеціаліст? Ця інформація буде відображатися на сайті.",
        aboutInfoLabel: "Про себе:",
        aboutResizeHint: "Щоб розширити текстове поле - просто потягніть мишкою за правий нижній куток рамки.",
        shortDescription: "Короткий опис",
        shortDescriptionLead: "Це ваше коротке позиціонування на картці спеціаліста. Влучний опис підкаже клієнту, чи саме ви той фахівець, якого він шукає, та заохотить перейти у ваш профіль.",
        shortDescriptionNote: "Сформулюйте ваш головний меседж: із якими запитами ви працюєте та в чому цінність сесій із вами.",
        shortDescriptionTooLong: "Не більше 300 символів",
        aboutTitle: "Розкажіть про себе та свій підхід до роботи",
        aboutLead: "Поділіться тим, що, на вашу думку, важливо знати майбутньому клієнту:",
        aboutPoint1: "У яких напрямах та з якими запитами ви працюєте?",
        aboutPoint2: "Яких принципів дотримуєтеся в терапії?",
        aboutPoint3: "Що для вас важливо у взаємодії з людиною?",
        aboutNote: "Ця інформація відображатиметься у вашій картці в каталозі та допоможе клієнтам відчути, чи підходите ви їм як фахівець.",

        youtube: "Посилання на відеовізитівку в YouTube",
        youtubeLabel: "Посилання (YouTube)",
        video: "Посилання на відеовізитівку",
        videoLabel: "Посилання",
        videoOptional: "Це не обов'язкове поле при реєстрації.",
        videoHint: "Якщо ви використовуєте Google Drive, переконайтеся, що відкрито доступ для всіх за посиланням",

        consultingExperience:
          "Скільки років ви консультуєте? За кошти, не в рамках навчальної програми.",
        consultingExperienceLabel: "Досвід роботи",
        additionalProgram:
          "Які додаткові програми пройшли чи проходите на даний момент?",
        coursesLabel: "Повна назва та кількість пройдених годин",
        selfTherapy: "Чи проходите ви персональну психотерапію?",
        regularSupervision: "Чи проходите ви регулярно супервізії?",
        yes: "Так",
        no: "Ні",
        save: "Зберегти",
        update: "Оновити",
        yourCertificates: "Ваші сертифікати",
        uploadDoc: "Завантажити документ",
        cancel: "Скасувати",
        accept: "Підтвердити",
        download: "Переглянути",
        delete: "Видалити",

        rules: "Поле обовя'зкове для заповнення.",
        nameRules: "Поле \"Ім'я\" обов'язкове для заповнення",
        lastnameRules: 'Поле "Прізвище" обов\'язкове для заповнення',
        emailRules1: 'Поле "E-mail" обов\'язкове для заповнення',
        emailRules2: "E-mail повинен бути валідним",
        youtubeRules1: "Некоректне посилання YouTube",
        consultingExperienceRules1: "Обов'язкове для заповнення",
        consultingExperienceRules2: "Некоректні дані",
        consultingExperienceRules3: "Будь ласка, введіть достовірні дані",
        coursesRules1: "Поле обов'язкове для заповнення",
        coursesRules2: "Це поле повинно містити не менше 10 символів",
        countrySelectorLabel: "Код країни",
        countrySelectorError: "Помилка країни",
        phoneNumberLabel: "Номер телефону",
        example: "Приклад :",
        year: "рік",
        years: "років",
        years2: "року",
        error: "Ви ще не можете змінювати це поле.",
      },
      mainPage: {
        currentClient: "Поточний клієнт:",
        clientsProblem: "Проблеми клієнта:",
        rating: "Ваш рейтинг:",
        nextSession: "Найближча сесія:",
        skipNextSession: "Скасувати сесію",
        todayClients: "Ваші клієнти на сьогоднішній день",
        webRTC: {
          connection: "Підключаємось...",
          nextSessionWillBee: "Наступна сесія буде",
          textInformationInVideoPlayer:
            "У момент початку Вашого сеансу кнопка для підключення до дзвінка з'явиться нижче.",
          connectToCallBtn: "Приєднається до дзвінка",
          rateTheSession: "Оцініть сесію",
          rateBtn: "Оцінити",
          settings: "Налаштування",
          scanningNextSession: "Скануємо..",
          psychologistSpinnerMessage:
            "Клієнт ще не приєднався, будь ласка, чекайте...",
          clientSpinnerMessage: "Психолог ще не приєднався, будь ласка...",
          remoteStatusVueSwall: "приєднується",
          warningCallWillFinishVueSwall:
            "УВАГА! Дзвінок закінчиться за 5 хвилин.",
        },
      },
      welcomeMessage: {
        hello: "Доброго дня,",
        title: "Раді вітати у вашому робочому кабінеті на Платформі",
        subtitle: "Ваша анкета зараз знаходиться на розглядані.",
        description:
          "Це означає, що ви не можете вести діяльність, поки ваш профіль не буде підтверджений адміністратором!",
        informing:
          "Після розгляду анкети (може розглядатися до 2-х тижнів) ми зв'яжемось з вами та домовимось про співбесіду.",
        informing2: "Слідкуйте за електронною поштою.",
      },
      schedule: {
        swallCancelSessionByPsychologist: "Скасовуємо сеанс..",
        swallCancelSessionByPsychologistTitle:
          "Ви впевнені що хочете скасувати сеанс?",
        swallYes: "Так",
        swallNo: "Нi",
        client: "Клієнт: ",
        instruction: "Інструкція",
        calendarTitle: "Заповнення календаря не є обов'язковим, але це суттєво підвищує довіру клієнтів!",
        calendarText: "Актуальний графік показує, що ви активний фахівець, який відповідально ставиться до своєї практики. Клієнтам набагато простіше та комфортніше звертатися до психолога, чий вільний час вони бачать одразу.",
        calendarCta: "Регулярно заповнюйте календар, щоб збільшити кількість звернень та конверсію записів!",
        example1: "Приклад 1",
        exampleDesk11: "- Час, коли ви ",
        exampleDesk12: "Не Готові ",
        exampleDesk13: "працювати (клієнту не відображається цей час)",
        example2: "Приклад 2",
        exampleDesk21: "- Час, коли ви ",
        exampleDesk22: "Готові ",
        exampleDesk23:
          "працювати (клієнту  відображається цей час для запису).",
        example3: "Приклад 3",
        exampleDesk31:
          "- Час, заброньований клієнтом для роботи. У вас є можливість скасувати консультацію, так як до неї ще більше ніж 24 години",
        // exampleDesk32: "Ви не відображаєтесь ",
        // exampleDesk33:
        //   "іншим клієнтам. А також ви маєте можливість скасувати сеанс, тому, що до сеансу більш ніж 24 години.",
        example4: "Приклад 4",
        exampleDesk41:
          "- Час, заброньований кліентом для роботи. Але ви не маєте можливості скасувати консультацію, так як до неї залишилось меньше ніж 24 години",
        // exampleDesk42: "Ви також не відображаєтесь ",
        // exampleDesk43:
        //   "іншим клієнтам . А також у Вас немає можливості скасувати сеанс, тому, що до сеансу менше ніж 24 години.",
      },
    },
    patientDashboard: {
      myQuestions: {
        title: "Мої запитання",
        ask: "Поставити запитання",
        empty: "Тут будуть ваші запитання з форуму і відповіді психологів на них.",
        toForum: "Перейти на форум",
        new: "Нові відповіді:",
        pending: "На перевірці",
        noAnswers: "Відповідей ще немає",
        answerForms: "відповідь|відповіді|відповідей",
        openOnSite: "Відкрити на сайті",
        newMark: "нове",
        you: "Ви",
        clarify: "Уточнити питання",
        clarifyHint: "Уточнення з’явиться на форумі під відповіддю психолога",
        send: "Надіслати",
        tooShort: "Напишіть уточнення",
        failed: "Не вдалося надіслати. Спробуйте пізніше",
      },
      favorites: {
        addFavorite: "Додати в обрані",
        removeFavorite: "Прибрати з обраних",
        title: "Обрані психологи",
        empty: "Тут будуть психологи, яких ви додали в обрані. Натисніть сердечко на картці або в анкеті психолога на сайті.",
        toCatalog: "Перейти до каталогу",
        remove: "Прибрати з обраних",
        open: "Дивитись анкету",
      },
      blog: {
        header:
          "Мудра порада, цікава історія, список корисних лайфхаків чи наукова стаття. Хто знає, яке знання припаде вам до душі сьогодні?",
        subtitle1: "Добре, що ми маємо вибір.",
        subtitle2:
          "Найкращі статті допоможуть знайти відповіді на непрості та вкрай важливі питання, відпочити душею та познайомитися з думкою експертів проєкту.",
        andMore: "...і ще багато цікавого",
      },
      main: {
        swallCancelSession: "Скасуємо попередній сеанс..",
        swallBookedSession: "Бронюємо новий сеанс..",
        userAgreementLink: "угоді користувача.",
        paymentBtn: "Прив'язати карту",
        paymentMethodWarning:
          "Сеанс буде автоматично скасовано. Щоб цього не сталося, прив'яжіть карту для оплати.",
        hello: "Доброго дня ",
        yourTherapist: "Ваш терапевт: ",
        nonTherapist: "На даний момент у Вас немає терапевта.",
        chooseTherapist: "Обрати терапевта",
        switchTherapist: "Змінити терапевта",
        warning:
          "Для відображення повного функціонала - необхідно прив'язати карту.",
        connectCard: "Прив'язати карту",
        nextSession: "Наступна сесія",
        shiftSession: "Перенести сесію",
        shiftSessionOnSelectedTime: "Перенести сесію на",
        cancelSession: "Скасувати сесію",
        bookedSession: "Забронювати сесію",
        bookedSessionOnSelectedTime: "Забронювати сесію на",
        warningSession1:
          "Переносити можна не пізніше ніж за 12 годин до початку сесії. Повні умови читайте в ",
        warningSession2: "угоді користувача ",
        and: "і ",
        warningSession3: "договорі надання послуг ",
        withPsychologist: "з психологом ",
        cancel: "Відміна",
        shiftTo: "Перенести на ",
      },
      settings: {
        timezone: "",
        title: "Особисті дані",
        name: "Ваше ім'я:",
        age: "Скільки вам років?",
        contacts: "Контакти і налаштування повідомлень",
        smsNotification: "СМС-повідомлення за 1 годину до початку сеансу",
        hint: "Ваш e-mail використовується для нагадування про майбутні сеанси",
        blogLabel: "Хочу отримувати новини сервісу",
        // blogLabel: "Новини сервісу і важливе з блогу",
        notificationLabel: "Сповіщення по почті",
        timeLabel: "Оберіть час",
        beforeSession: "до початку сеансу.",
        save: "Зберегти",
        refresh: "Оновити",
        infoText1: "Підпишіться на",
        infoText2: "щоб отримати швидку підтримку або знайти відповіді на часті запитання",
        infoText3: "Сповіщення будуть приходити на пошту та в Telegram-бот",
        infoTextList1: "- одразу після оплати сеансу",
        infoTextList2: "- одразу після перенесення чи скасування сеансу",
        infoTextList3: "- за 1 годину до початку сеансу",
        infoTextList4: "- коли психотерапевт створив для вас попереднє бронювання сеансу",
        infoTextList5: "- коли психотерапевт скасував попереднє бронювання сеансу",
      },
      ourPsychologists: {
        oops: "Упс..ми нічого не змогли знайти по твоєму запиту: з",
        workExperience: "Досвід роботи ",
        showFully: "Показати повністю..",
        chooseDateTime: "Оберіть дату та час:",
        chooseTime: "Оберіть час",
        book: " Забронювати ",
        on: "на ",

        lifeEvent: "Життєві ситуації",
        condition: "Стан",
        relationship: "Стосунки",
        career: "Робота, кар'єра, навчання",

        stress: "Стрес",
        panic_attacks: "Панічні атаки",
        low_self_esteem: "Низька самооцінка",
        sleep_problems: "Проблеми зі сном",
        emotional_addiction: "Емоційна залежність",
        hypochondria: "Іпохондрія, занепокоєння про здоров'я",
        alcohol_drugs_addiction: "Залежність, від алкоголю, наркотиків",

        anxiety: "Страх, тривожність",
        breakdown: "Знесилення",
        mood_swings: "Перепади настрою",
        irritability: "Роздратування",
        feelings_of_loneliness: "Почуття самотності",
        social_network_addiction: "Залежність від соціальних мереж",
        eating_disorders: "Розлад харчової поведінки",

        with_partner: "З партнером",
        with_children: "З дітьми",
        sexual: "Сексуальні",
        with_parents: "З батьками",
        common: "В цілому, з оточуючими",

        stress_at_work: "Стрес, вигорання",
        procrastination: "Прокрастинація",
        no_goal: "Відсутність цілі",
        lack_of_motivation: "Недостатньо мотивації",
        cannot_find_myself: '"Не знаю, чим хочу займатися"',
        job_loss_change: "Зміна, втрата роботи",

        relocate_emigration: "Переїзд, еміграція",
        financial_changes: "Фінансові зміни",
        betrayal: "Зрада",
        illness: "Хвороба, своя чи близьких",
        pregnancy: "Вагітність, народження дитини",
        divorce: "Розрив стосунків, розлучення",
        violence: "Насильство",
        loss_of_a_loved_one: "Втрата близької людини",
        family_conflicts: "Сімейні конфлікти",
      },
      payment: {
        cardInfo: "Данні платіжної карти",
        cardDesk:
          "Дана картка використовується для оплати консультацій із Вашим терапевтом.",
        untieCard: "Відв'язати картку",
        untieCardDesk: "Ваша карта не прив'язана",
        bookInfo: "Для бронювання консультації необхідно прив’язати платіжну карту",
        connectCard: "Прив'язати карту ",
        cancel: "Скасувати",
        cardNumber: "Номер карти",
        cardOwner: "Власник карти",
        expireDate: "Термін дії",
        month: "Місяць",
        year: "Рік",
      },
    },
    patientReg: {
      title: "Реєстрація клієнта",
      agreeText: "Реєструючись, ви погоджуєтесь з",
      agreeTerms: "угодою користувача",
      agreeAnd: "та",
      agreePolicy: "політикою конфіденційності",
      generalQuestions: "Загальні питання",
      personalQuestions: "Особисті питання",
      therapists: "Вибір терапевта",
      terms: "Умови оплати",
      further: "Далі",
      back: "Назад",
      apply: "Зареєструватись",
      select: "Обрати",
      stepOne: {
        yourName: "Як вас звати?",
        nameDesk: "Ваше ім'я буде доступне вашому психологу",
        nameLabel: "Ім'я",
        yourAge: "Скільки вам років?",
        ageDesk: "Для отримання послуг ви повинні бути старше 16 років",
        ageLabel: "Вік",
        therapyExperience: "Чи був у вас досвід терапії?",
        whichConsultationType: "Яка консультація потрібна?",
        yes: "Так",
        no: "Ні",
        consultationType: "Оберіть тип консультації",
        single: "Для себе",
        family: "Сімейна",
        timeZone: "Часовий пояс",
        patientNameRules: "Поле \"Ім'я\" обов'язково при заповненні",
        patientAgeRules1: 'Поле "Вік" обов\'язково при заповненні',
        patientAgeRules2:
          "Для отримання послуг ви повинні бути старше 16 років.",
        patientEmailRules1: 'Поле "E-mail" обов\'язково при заповненні',
        patientEmailRules2: "E-mail має бути валідним",
      },
      stepTwo: {
        selectThemes: "Оберіть теми, з якими ви бажаєте працювати з психологом",
        warning: "Необхідно вибрати хоча б одну тему",
        whatDiscuss: "Що ви хотіли б обговорити насамперед?",
        lifeEvent: "Життєві ситуації",
        condition: "Стан",
        relationship: "Стосунки",
        career: "Робота, кар'єра, навчання",

        relocate_emigration: "Переїзд, еміграція",
        financial_changes: "Фінансові зміни",
        betrayal: "Зрада",
        illness: "Хвороба, своя чи близьких",
        pregnancy: "Вагітність, народження дитини",
        divorce: "Розрив стосунків, розлучення",
        violence: "Насильство",
        loss_of_a_loved_one: "Втрата близької людини",
        family_conflicts: "Сімейні конфлікти",

        stress: "Стрес",
        panic_attacks: "Панічні атаки",
        low_self_esteem: "Низька самооцінка",
        sleep_problems: "Проблеми зі сном",
        emotional_addiction: "Емоційна залежність",
        hypochondria: "Іпохондрія, занепокоєння про здоров'я",
        alcohol_drugs_addiction: "Залежність, від алкоголю, наркотиків",

        anxiety: "Страх, тривожність",
        breakdown: "Знесилення",
        mood_swings: "Перепади настрою",
        irritability: "Роздратування",
        feelings_of_loneliness: "Почуття самотності",
        social_network_addiction: "Залежність від соціальних мереж",
        eating_disorders: "Розлад харчової поведінки",

        with_partner: "З партнером",
        with_children: "З дітьми",
        sexual: "Сексуальні",
        with_parents: "З батьками",
        common: "В цілому, з оточуючими",
        stress_at_work: "Стрес, вигорання",
        procrastination: "Прокрастинація",
        no_goal: "Відсутність цілі",
        lack_of_motivation: "Недостатньо мотивації",
        cannot_find_myself: '"Не знаю, чим хочу займатися"',
        job_loss_change: "Зміна, втрата роботи",
      },
      stepThree: {
        workExperience: "Досвід роботи",
        worksWith: "Працює з",
        outOf: "із",
        topics: "тем Вашої анкети",
        soon: "Найближчий час:",
        selectSessionTime: "Обрати час сеансу",
        aboutSpecialist: "Про спеціаліста",
        canContactMe: "Ви можете звернутися до мене:",
        education: "Освіта",
        therapyMethod: "Метод терапії",
        workTopics: "Спеціаліст працює з темами з вашої анкети:",
        dateAndTime: "Оберіть дату та час сеансу",
        canShift: "Можливо перенести за 12 годин",
        price: "Фіксована ціна {0} ",
      },
      stepFour: {
        price: "Вартість сеансу становить ",
        termsPart1: "Після того, як ви прив'яжете карту, ми знімемо з неї",
        termsPart2:
          "і одразу ж повернемо назад. Це стандартна процедура перевірки.",
        termsPart31: "Кошти знімаються з карти ",
        termsPart32: "за 12 годин ",
        termsPart33:
          "до сесії – і після того, як це сталося, ви вже не зможете її перенести або скасувати.",
        termsPart41: "Ви в будь-який момент ",
        termsPart42: "можете відв'язати ",
        termsPart43: "свою карту. Це можливо зробити в особистому кабінеті.",
        termsPart5:
          "Всі сеанси проводяться по відеозв'язку з особистого кабінету і вам необхідне стабільне підключення до інтернету.",
        important: "Важливо! ",
        termsPart6: `Натискаючи кнопку «Прив'язати карту» ви підтверджуєте, що ознайомлені та згідні з договором надання послуг та даєте згоду на обробку персональних даних.`,
        psychologist: "Терапевт:",
        sessionDate: "Дата та час сеансу:",
      },
    },
    psychologistReg: {
      networkError: "Щось пішло не так. Можливо, ви намагаєтеся завантажити занадто великі файли.",
      emailCodeSpam: "Якщо ви не бачите листа, перевірте теку Спам",
      emailCode:
        "Вам було надіслано код на вказану пошту, введіть його у поле вище, будь ласка.",
      generalInformation: "Загальна інформація",
      mainTreatmentMethod: "Основний метод",
      workExperience: "Досвід роботи",
      aboutInfo: "Розкажіть про себе",
      further: "Далі",
      back: "Назад",
      apply: "Подати заявку",
      stepOne: {
        sex: 'Стать',
        male: 'Чоловіча',
        female: 'Жіноча',
        desk: "Деякі поля необхідно заповнити двома мовами",
        phoneRules: 'Поле "телефон" обов\'язково при заповненні',
        phoneRules2: 'Поле "телефон" повинно містити тільки цифри',
        birthRule:
          'Поле "дата народження" повинно бути в форматі "рік-місяць-день"',
        firstName: "Ім'я",
        secondName: "Прізвище",
        patronymic: "По батькові",
        dateOfBirth: "Дата народження",
        citizenship: "Громадянство",
        phone: "Телефон",
        university: "Назва ВНЗ",
        faculty: "Назва факультету",
        speciality: "Спеціальність",
        scienseDegree: "Академічний чи науковий ступінь",
        yearOfEnding: "Рік закінчення",
        year: "Рік",
        education: "Освіта",
        add_education: "Додати освіту",
        descRules: 'Поле "Описание" обов\'язково при заповненні',
        descRulesUA: 'Поле "Опис" обов\'язково при заповненні',
        photoDesc:
          "Будь ласка, прикріпіть фотографії розгорнутих дипломів та сертифікатів, що підтверджують навчання",
        diploma_and_certificates: "Дипломи та сертифікати",
        nameRules: "Поле \"Ім'я\" обов'язково при заповненні",
        lastnameRules: 'Поле "Прізвище" обов\'язково при заповненні',
        emailRules1: "E-mail має бути валідним",
        emailRules2: 'Поле "E-mail" обов\'язково при заповненні',

        educationRules: 'Поле "Освіта" обов\'язково при заповненні',
        universityRules: 'Поле "Назва ВНЗ" обов\'язково при заповненні',
        facultyRules: 'Поле "Назва факультету" обов\'язково при заповненні',
        specialityRules: 'Поле "Спеціальність" обов\'язково при заповненні',
        sexRules: 'Поле "Стать" обов\'язково при заповненні',
        scienceDegreeRules:
          'Поле "Академічний чи науковий ступінь" обов\'язково при заповненні',

        yearOfEndingRules1: 'Поле "Рік закінчення" обов\'язкове при заповненні',
        yearOfEndingRules2: 'Поле "Рік закінчення" повинно містити 4 символи',
        yearRules1: 'Поле "Рік" обов\'язкове при заповненні',
        yearRules2: 'Поле "Рік" повинно містити 4 символи',
        citizenshipRules: 'Поле "Громадянство" обовязково при заповненні',

        bachelors: "Бакалавр",
        master: "Магістр",
        doctoral: "Доктор наук",
        candidate_of_sciences: "Кандидат наук",
        diploma_and_certificates_desk: "Основні та додаткові",
      },
      stepTwo: {
        another: "Інше",
        mainTreatmentMethod: "Оберіть Ваш основний метод:",
        additionalEducation:
          "Виберіть, якщо у вас є додаткова освіта, яка стосується наступних тем:",
        additionalEducationDesk:
          "Напишіть, будь ласка, в якій галузі маєте додаткову освіту?",
        problems: "Виберіть проблеми з якими ви можете допомогти:",

        art_therapy: "Арт-терапія",
        positive_psychotherapy: "Позитивна психотерапія",
        client_centered_psychotherapy: "Клієнт-центрована психотерапія",
        cognitive_behavioral_therapy: "Когнітивно-поведінкова терапія",
        body_therapy: "Тілесна терапія",
        psychoanalysis: "Психоаналіз",
        jungian_analysis: "Юнгіанський аналіз",
        transactional_analysis: "Транзакційний аналіз",
        family_therapy: "Сімейна терапія",
        gestalt_therapy: "Гештальт-терапія",
        psychodrama: "Психодрама",
        analytical_psychology: "Аналітична психологія",
        symboldrama: "Символдрама",
        existential_analysis: "Екзистенційний аналіз",
        nlp: "НЛП",
        emdr: "EMDR",
        schema_therapy: "Схема-терапія",
        emotional_imagery_therapy: "Емоційно-образна терапія",
        integrative_approach: "Інтегративний підхід",
        act_therapy: "АСТ-терапія",
        hypnotherapy: "Гіпнотерапія",
        coaching: "Коучинг",
        logotherapy: "Логотерапія",
        children: "Дитячий психолог",
        teenagers: "Психолог для підлітків",

        addictions: "Залежності",
        sexology: "Сексологія",
        extreme_situations: "Екстремальні ситуації, ПТСР",
        couples_therapy: "Парна терапія",
        lgbt: "ЛГБТК+",

        lifeEvent: "Події життя",
        condition: "Стан",
        relationship: "Стосунки",
        career: "Робота, кар'єра, навчання",

        relocate_emigration: "Переїзд, еміграція",
        financial_changes: "Фінансові зміни",
        betrayal: "Зрада",
        illness: "Хвороба, своя чи близьких",
        pregnancy: "Вагітність, народження дитини",
        divorce: "Розрив стосунків, розлучення",
        violence: "Насильство",
        loss_of_a_loved_one: "Втрата близької людини",
        family_conflicts: "Сімейні конфлікти",

        stress: "Стрес",
        panic_attacks: "Панічні атаки",
        low_self_esteem: "Низька самооцінка",
        sleep_problems: "Проблеми зі сном",
        emotional_addiction: "Емоційна залежність",
        hypochondria: "Іпохондрія, занепокоєння про здоров'я",
        alcohol_drugs_addiction: "Залежність, від алкоголю, наркотиків",

        anxiety: "Страх, тривожність",
        breakdown: "Знесилення",
        mood_swings: "Перепади настрою",
        irritability: "Роздратування",
        feelings_of_loneliness: "Почуття самотності",
        social_network_addiction: "Залежність від соціальних мереж",
        eating_disorders: "Розлад харчової поведінки",

        with_partner: "З партнером",
        with_children: "З дітьми",
        sexual: "Сексуальні",
        with_parents: "З батьками",
        common: "В цілому, з оточуючими",
        stress_at_work: "Стрес, вигорання",
        procrastination: "Прокрастинація",
        no_goal: "Відсутність цілі",
        lack_of_motivation: "Недостатньо мотивації",
        cannot_find_myself: '"Не знаю, чим хочу займатися"',
        job_loss_change: "Зміна, втрата роботи",
      },
      stepThree: {
        year: "рік",
        years: "років",
        years2: "року",
        years3: "роки",
        workExperienceLabel: "Досвід роботи",
        workExperience:
          "Скільки років ви консультуєте? За кошти, не в рамках навчальної програми.",
        additionalProgram:
          "Які додаткові програми пройшли чи проходите на цей момент?",
        additionalProgramLabel: "Повна назва та кількість пройдених годин",
        selfTherapy: "Чи проходите ви персональну психотерапію?",
        regularSupervision: "Чи проходите ви регулярно супервізії?",
        rules: "Поле обов'язкове для заповнення",
        consultingExperienceRules1: "Некоректні дані",
        consultingExperienceRules2: "Будь ласка, введіть достовірні дані",
        coursesRules: "Це поле повинно містити не менше 10 символів",
        yes: "Так",
        no: "Ні",
      },
      stepFour: {
        swallWriteToDB: "Створюємо обліковий запис",
        aboutInfo:
          "Розкажіть про себе у вільній формі. Що вважаєте нам потрібно дізнатися про вас, щоб зрозуміти, який ви спеціаліст?",
        warning: "Ця інформація буде відображена на сайті",
        notWorkingWith: "З чим ви не працюєте?",
        infoChannel: 'Як ви дізналися про набір терапевтів в "Платформа"?',
        clientsQuantity:
          'Яку кількість клієнтів ви готові взяти в "Платформа"?',
        from: "Від",
        to: "До",
        mediaLinksTitle: "Вкажіть посилання на профілі в соціальних мережах ",
        photoTitle: "Додайте ваше фото",
        photoLabel: "Ваше фото",
        requirements: "Вимоги до фото:",
        requirements1: "Кольорове",
        requirements2: "Обличчя по центру і добре освітлене",
        requirements3: "Розмір не менше 1МБ",
        requirements4: "В форматі (назва).jpg",
        socialMediaLinksMin50: "Це поле має містити більше ніж 10 символів",
        socialMediaLinks2k: "Це поле має містити не більше 2000 символів",
        rules: "Поле обов'язково при заповненні",
        textAreaValidationRulesMin50:
          "Це поле має містити більше ніж 50 символів",
        textAreaValidationRules: "Це поле має містити не більше 2000 символів",
        entrepreneurRules: "Це поле має містити не менше 10 символів",
      },
    },
    footer: {
      tagline: "Каталог перевірених психологів",
      diiaCatalog: "Платформа в каталозі",
      agreement: "Угода користувача",
      privacy: "Політика конфіденційності",
      rights: "Усі права захищені.",
      supportBotText: "Підтримка",
      rateUs: "Оцініть нас",
      questions: "Залишились питання? ",
      contacts: "Ми завжди на зв'язку",
      legal: {
        mainText:
          ' <b>Важливий момент.</b> "Платформа" — це не швидка психологічна\n' +
          "            допомога. Якщо у вас серйозні проблеми, що загрожують вашому життю,\n" +
          "            котрі потребують негайного вирішення, вам краще звернутися в\n" +
          "            будь-яку з цих організацій.",
        userAgreementPart1: "Реєстрація на сайті означає згоду з",
        userAgreementLink: "угодою користувача.",
        userAgreementPart2: "Політика у відношенні ",
        userAgreementLink2: "обробки та захисту персональних даних",
        terms:
          "При використанні будь-яких матеріалів цього сайту, посилання на джерело обов'язкове.",
        protected: "Всі права захищені!",
      },
      footerMenu: {
        aboutProject: "Про проєкт",
        forPsychologists: "Для психологів",
        forBusinessShort: "Для бізнесу",
        services: "Каталог послуг",
        askQuestion: "Поставити запитання",
        expertArticles: "Експертні статті",
        tests: "Психологічні тести",
        events: "Події психологів",
        FAQ: "Питання-відповіді",
        Contacts: "КОНТАКТИ",
        workOffers: "РОБОТА В ПЛАТФОРМА",
        blog: "БЛОГ",
        ourPsychologists: "НАШІ ПСИХОЛОГИ",
        forBusiness: "ПЛАТФОРМА ДЛЯ БІЗНЕСУ",
      },
    },
  },
  view: {
    room: {
      title: "Відеоконсультація",
      with: "Психолог",
      yourName: "Ваше ім'я",
      join: "Увійти в кімнату",
      waitingHost: "Психолог ще не відкрив кімнату. Сторінка оновиться сама, щойно він підключиться.",
      busy: "Зараз у психолога інший клієнт. Спробуйте трохи пізніше.",
      notFound: "Кімнату не знайдено. Перевірте посилання.",
      connecting: "З'єднання з психологом…",
      connected: "З'єднано",
      leave: "Вийти",
      left: "Ви вийшли з кімнати",
      rejoin: "Увійти знову",
      kicked: "Психолог завершив зустріч",
      cameraError: "Немає доступу до камери або мікрофона. Дозвольте доступ у браузері й оновіть сторінку.",
      mic: "Мікрофон",
      camera: "Камера",
    },
    common: {
      methodOfWork: 'Метод роботи',
      aboutSpecialist: 'Про фахівця',
      education: 'Освіта',
      worksWith: 'Працює з темами',
      typeOfConsultation: 'Вид консультації',
      schedule: 'Розклад',
      more: 'Більше',
      less: 'Менше',
      сhoose: 'Обрати',
      videoIntroduction: 'Відеовізитівка',
      individualSession: 'Індивідуальна сесія 50 хв',
      couplesSession: 'Парна сесія 90 хв',
      forMyself: 'Для себе',
      couples: 'Парна',
      additionTextConsultationType1Time: '50 хв',
      additionTextConsultationType2Time: '1,5 год',
    },
    psychologists: {
      oops: 'Упс..ми нічого не змогли знайти по твоєму запиту.',
      preview: {
        mainTitle: 'Наші фахівці',
        subtitle: 'Кваліфіковані фахівці з перевіреною освітою і досвідом, які пройшли суворий відбір Платформи'
      },
      filters: {
        filters: 'Фільтри',
        show_psychologists: 'Показати психолога(ів)',
        clear: 'Очистити',
        show: 'Показати',
        close: 'Закрити',
        symptoms: 'Симптоми',
        specialization: 'Метод роботи',
        sex: 'Стать',
      },
      sex_options: {
        male: 'Чоловіча',
        female: 'Жіноча',
      },
      sort_options: {
        default: 'Рекомендовані',
        exp_desc: 'Спочатку більш досвідчені',
        price_desc: 'Спочатку дорожче',
        price_asc: 'Спочатку дешевше',
      },
      specialization: {
        title: "В даному розділі ви можете відредагувати анкетні дані",
        subtitle: "Оберіть, проблеми з якими ви можете допомогти:",
        main_treatment_method: "Оберіть Ваш основний метод:",
        additionalEducation:
          " Оберіть, якщо у вас є додаткова освіта, що стосується наступних тем:",
        other: "Інше",
        anotherSelectTextArea:
          "Напишіть, будь ласка, в якій сфері у вас є додаткова освіта?",

        art_therapy: "Арт-терапія",
        positive_psychotherapy: "Позитивна психотерапія",
        client_centered_psychotherapy: "Клієнто-центрована психотерапія",
        cognitive_behavioral_therapy: "Когнітивно-поведінкова терапія",
        body_therapy: "Тілесна терапія",
        psychoanalysis: "Психоаналіз",
        jungian_analysis: "Юнгіанський аналіз",
        transactional_analysis: "Транзакційний аналіз",
        family_therapy: "Сімейна терапія",
        gestalt_therapy: "Гештальт-терапія",
        psychodrama: "Психодрама",
        analytical_psychology: "Аналітична психологія",
        symboldrama: "Символдрама",
        existential_analysis: "Екзистенціальний аналіз",
        nlp: "НЛП",
        emdr: "EMDR",
        schema_therapy: "Схема-терапія",
        emotional_imagery_therapy: "Емоційно-образна терапія",
        integrative_approach: "Інтегративний підхід",
        act_therapy: "АСТ-терапія",
        hypnotherapy: "Гіпнотерапія",
        coaching: "Коучинг",
        logotherapy: "Логотерапія",
        children: "Дитячий психолог",
        teenagers: "Психолог для підлітків",

        addictions: "Залежності",
        sexology: "Сексологія",
        extreme_situations: "Екстремальні ситуації, ПТСР",

        // psychologist filters
        life_event_problems: "Життєві ситуації",
        mental_health_condition_problems: "Стан",
        relationship_problems: "Стосунки",
        career_problems: "Робота, кар'єра, навчання",
        /******************************************/

        relocate_emigration: "Переїзд, еміграція",
        financial_changes: "Фінансові зміни",
        betrayal: "Зрада",
        illness: "Хвороба, своя чи близьких",
        pregnancy: "Вагітність, народження дитини",
        divorce: "Розрив стосунків, розлучення",
        violence: "Насильство",
        loss_of_a_loved_one: "Втрата близької людини",
        family_conflicts: "Сімейні конфлікти",

        stress: "Стрес",
        panic_attacks: "Панічні атаки",
        low_self_esteem: "Низька самооцінка",
        sleep_problems: "Проблеми зі сном",
        emotional_addiction: "Емоційна залежність",
        hypochondria: "Іпохондрія, занепокоєння про здоров'я",
        alcohol_drugs_addiction: "Залежність, від алкоголю, наркотиків",

        anxiety: "Страх, тривожність",
        breakdown: "Знесилення",
        mood_swings: "Перепади настрою",
        irritability: "Роздратування",
        feelings_of_loneliness: "Почуття самотності",
        social_network_addiction: "Залежність від соціальних мереж",
        eating_disorders: "Розлад харчової поведінки",

        with_partner: "З партнером",
        with_children: "З дітьми",
        sexual: "Сексуальні",
        with_parents: "З батьками",
        common: "В цілому, з оточуючими",
        gender_identity_exploration: "Пошук гендерної ідентичності",

        stress_at_work: "Стрес, вигоряння",
        procrastination: "Прокрастинація",
        no_goal: "Відсутність цілі",
        lack_of_motivation: "Недостатньо мотивації",
        cannot_find_myself: '"Не знаю, чим хочу займатися"',
        job_loss_change: "Зміна, втрата роботи",

        save_changes: "Зберегти зміни",
      }
    },
    psychDescrModal: {
      session: 'Сесія',
      showAll: 'Показати повністю..',
      seeAll: 'Дивитись повністю',
      aboutMyself: 'Про себе',
      methodOfWork: 'Метод роботи',
      book: 'Забронювати',
      close: 'Закрити',
      experiense: 'Досвід роботи ',
      experience_with_years: 'Досвід роботи {count} {year}',
      yearForms: 'рік|роки|років'
    },
    blog: {
      search: "Пошук по статтях",
      categories: "Категорії",
      title: "Ми вибачаємося.",
      subtitle: "Цей розділ знаходиться в розробці.",
      localisationWarning: "Стаття написана 1-ою мовою",
      posted: "Опубліковано",
      close: "Закрити",
      readMore: "Читати статтю повністю",
      nextPost: "Наступниа стаття",
      previousPost: "Попереднія стаття",
    },
    signIn: {
      registrationProviderExpired: "Вхід через Google або Apple застарів. Увійдіть ще раз і поверніться до анкети: заповнені поля збережуться, фото й сертифікати треба буде додати знову.",
      registrationProviderOnly: "Для реєстрації спочатку увійдіть через Google або Apple — так ви зможете входити в кабінет без SMS.",
      smsDisabled: "Вхід за SMS вимкнено. Увійдіть через Google або Apple.",
      loginGoogleTitle: "Продовжити через Google",
      linkingLoginGoogleTitle: "Додати вхід через Google",
      loginAppleTitle: "Продовжити через Apple",
      linkingLoginAppleTitle: "Додати вхід через Apple",
      phoneText1: "введіть свій український номер телефону,",
      phoneText2: "ми надішлемо вам одноразовий код",
      phoneTextReg1: "введіть свій український номер телефону",
      phoneTextReg2: "",
      or: "або",
      title:
        "Будь ласка, введіть свій номер телефону з кодом країни, ми надішлемо вам одноразовий пароль",
      termsPart1: "Авторизуючись, ви приймаєте умови, ",
      termsPart2: "угоди користувача ",
      termsPart3: "даєте згоду на ",
      termsPart4: "обробку персональних даних ",
      termsPart5:
        "і даєте згоду на отримання СМС-паролей, а також інших інформаційних і сервісних повідомлень на вказаний номер телефону.",
      code: "Отримати код",
      continueBtn: "Продовжити",
      loading: "Завантаження...",
      countrySelectorLabel: "Код країни",
      countrySelectorError: "Помилка країни",
      phoneNumberLabel: "Номер телефону",
      example: "Приклад :",
      oldLoginLink1: "Налаштувати вхід",
      oldLoginLink2: "для номера телефону",
      loginLink: "Перейти до входу",
      linkingLoginText: "Оберіть зручний для вас спосіб входу для подальшої авторизації.",
      user_not_exists: "Ця операція недоступна для цього користувача.",
    },
    verify: {
      title: "ВВЕДІТЬ КОД",
      desk: "Код дійсний протягом 10 хвилин. Код надіслано!",
      resendCode: "Надіслати код повторно",
      resendCodeDesk:
        "Термін дії тимчасового коду минув. Надіслати код повторно?",
      accept: "Підтвердити",
      loading: "Завантаження...",
      viberCode1: "Не прийшов код ?",
      viberCode2: "Надіслати код на Viber",
    },
    registration: {
      welcomeMessagePsyh:
        "Якщо ви психолог та бажаєте стати частиною нашої команди",
      welcomeMessagePatient:
        "Якщо ви бажаєте знайти саме свого психолога та вирішити свій запит",
      desk: "Для початку роботи з Платформою необхідно пройти реєстрацію",
      patient: "Реєстрація для клієнта",
      psychologist: "Реєстрація для психолога",
      title:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. ",
    },
    restore: {
      text: "Ваш акаунт було видалено. Оберіть, що зробити далі:",
      restoreHint: "Відновити видалений акаунт і продовжити роботу.",
      restore: "Відновити аккаунт",
      deleteHint: "Видалити акаунт остаточно і зареєструватися заново.",
      delete: "Створити новий акаунт",
      user_not_exists: "Дані застаріли. Спробуйте ще раз.",
      error: "Сталася помилка. Будь ласка, повторіть спробу пізніше.",
      delete_success: "Акаунт остаточно видалено.",
      delete_dialog: "Ви дійсно бажаєте видалити акаунт назавжди?",
      user_exists: "Цей обліковий запис недоступний. Спробуйте інший.",
    },
    emailRegistration: {
      title: "Введіть Ваш E-mail",
      desk: 'Вся взаємодія з сервісом "Платформа" відбувається через листи на пошту. Ми надішлемо Вам листа з підсумком по Вашій анкеті.',
      accept: "Підтвердити",
      loading: "Завантаження...",
      emailRules1: 'Поле "E-mail" обов\'язково при заповненні',
      emailRules2: "E-mail має бути валідним",
    },
    auth: {
      logout: "Ви успішно були розлогінені!",
      psychologist: {
        Schedule: {
          title: "Розклад",
          subtitle:
            "Заповніть свій робочий графік, коли ви готові працювати з клієнтами Платформи.",
          description:
            "Розклад відображається у форматі - поточний день + 6 днів.",
          btnSave: "Зберегти",
          btnEdit: "Редагувати",
        },
      },
    },
  },

  developmentSection: {
    title: "Даний розділ знаходиться в розробці.",
  },
  pageNotFound: {
    Oops: "Уупс..",
    description: "Сторінка яку Ви шукаєте не існує. ",
  },
};
